import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api/client';

// Landing page after the e-sign provider: ?ref=...&status=...
const EsignCallback = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current) return;
    sent.current = true;
    api.post('/api/esign/callback/', { ref: params.get('ref'), status: params.get('status') })
      .then(() => navigate('/my-documents', { replace: true }))
      .catch((e) => setError(e.response?.data?.detail || 'Signing failed.'));
  }, [params, navigate]);

  return (
    <main style={{ padding: '4rem 1rem', textAlign: 'center' }}>
      {error ? (<><p role="alert">{error}</p><a href="/my-documents">Back to documents</a></>) : <p>Completing signature…</p>}
    </main>
  );
};

export default EsignCallback;
